import React from 'react'
import DatePicker from 'react-datepicker'
import PropTypes from 'prop-types'

import * as styles from '../../styles'

const DateInputComponent = ({
  tabIndex,
  selectedDate,
  showTimeSelect,
  selectsStart,
  selectsEnd,
  startDate,
  endDate,
  minDate,
  maxDate,
  minTime,
  maxTime,
  placeholder,
  timeIntervals,
  withPortal,
  disabled,
  readonly,
  className,
  dateFormat,
  timeFormat,
  showTimeInput,
  showYearDropdown,
  showMonthDropdown,
  onInternalChange,
  onBlur,
  ...props
}) => (
  <DatePicker
    tabIndex={tabIndex}
    placeholderText={placeholder}
    showTimeInput={showTimeInput}
    showTimeSelect={showTimeSelect}
    showYearDropdown={showYearDropdown}
    showMonthDropdown={showMonthDropdown}
    selectsStart={selectsStart}
    selectsEnd={selectsEnd}
    startDate={startDate}
    endDate={endDate}
    minDate={minDate}
    maxDate={maxDate}
    minTime={minTime}
    maxTime={maxTime}
    timeIntervals={timeIntervals}
    timeFormat={timeFormat}
    dateFormat={dateFormat}
    selected={selectedDate}
    disabled={disabled}
    readOnly={readonly}
    withPortal={withPortal}
    css={styles.input(props)}
    className={className}
    onChange={onInternalChange}
    onBlur={onBlur}
  />
)

DateInputComponent.propTypes = {
  tabIndex: PropTypes.number,
  className: PropTypes.string,
  placholder: PropTypes.string,
  timeFormat: PropTypes.string,
  dateFormat: PropTypes.string,
  selectsStart: PropTypes.bool,
  selectsEnd: PropTypes.bool,
  showYearDropdown: PropTypes.bool,
  showMonthDropdown: PropTypes.bool,
  startDate: PropTypes.shape(),
  endDate: PropTypes.shape(),
  minDate: PropTypes.shape(),
  maxDate: PropTypes.shape(),
  minTime: PropTypes.shape(),
  maxTime: PropTypes.shape(),
  timeIntervals: PropTypes.number,
  disabled: PropTypes.bool,
  readonly: PropTypes.bool,
  withPortal: PropTypes.bool,
  selectedDate: PropTypes.any,
  showTimeInput: PropTypes.bool,
  showTimeSelect: PropTypes.bool,
  onInternalChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
}

export default DateInputComponent
